// MCQSlide.tsx
import React, { useState } from "react";

export default function MCQSlide({ 
  slide, 
  sel, 
  setSel,
  onCorrect 
}) {
  const [done, setDone] = useState(false);
  const [showFeedback, setShowFeedback] = useState(false);
  const correct = slide.mcq?.answerIndex;

  function check() {
    if (sel === null) return;
    
    setDone(true);
    setShowFeedback(true);
    
    if (sel === correct) {
      setTimeout(() => {
        onCorrect();
      }, 100);
    }
  }

  return (
    <div className="p-4 border rounded bg-white shadow-sm">
      {/* Display the slide title */}
      {slide.title && <h3 className="font-bold text-lg mb-3 text-blue-800">{slide.title}</h3>}
      
      {/* Display the slide HTML content */}
      <div dangerouslySetInnerHTML={{ __html: slide.html }} />
      
      {/* Display the MCQ question */}
      <div className="mt-4 mb-4">
        <p className="font-semibold text-gray-800 text-lg">{slide.mcq?.question}</p>
      </div>
      
      {/* Display the answer options */}
      <ul className="mt-3 space-y-3">
        {slide.mcq?.options?.map((opt, i) => (
          <li 
            key={i} 
            className={`p-4 border-2 rounded-lg cursor-pointer transition-all duration-200 text-left ${
              sel === i 
                ? "border-blue-400 bg-blue-50" 
                : "border-gray-200 hover:border-gray-300 hover:bg-gray-50"
            } ${
              showFeedback && i === correct 
                ? "border-green-400 bg-green-50 animate-pulse" 
                : showFeedback && sel === i && i !== correct 
                ? "border-red-400 bg-red-50"
                : ""
            }`} 
            onClick={() => !done && setSel(i)}
          >
            <div className="flex items-center space-x-3">
              <div className={`w-4 h-4 rounded-full border-2 flex-shrink-0 ${
                sel === i ? "border-blue-500 bg-blue-500" : "border-gray-300"
              }`}>
                {sel === i && <div className="w-2 h-2 bg-white rounded-full m-auto mt-0.5"></div>}
              </div>
              <span className="text-base">{opt}</span>
            </div>
          </li>
        ))}
      </ul>
      
      <div className="mt-6 flex items-center gap-4">
        <button 
          className={`px-6 py-3 rounded-lg font-semibold transition-all duration-200 ${
            sel === null || done
              ? "bg-gray-300 text-gray-500 cursor-not-allowed"
              : "bg-blue-600 text-white hover:bg-blue-700 active:scale-95"
          }`} 
          onClick={check} 
          disabled={sel === null || done}
        >
          {done ? "Checked ✓" : "Check My Answer"}
        </button>
        
        {showFeedback && (
          <div className="text-base font-medium">
            {sel === correct ? (
              <div className="flex items-center space-x-2">
                <span className="text-2xl">🎉</span>
                <span className="text-green-600">Awesome! You got it right!</span>
              </div>
            ) : (
              <div className="flex items-center space-x-2">
                <span className="text-2xl">🤔</span>
                <span className="text-red-600">Oops! Try to think about it again!</span>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}